import { graphql } from "gatsby";

interface UnknownComponentAttributes {
  __typename: string;
}

const test = (_data: UnknownComponentAttributes): boolean => true;

const create = (data: UnknownComponentAttributes): JSX.Element => {
  // console.error(`Invalid content block: ${data?.__typename}`, data);

  return null;
};

export const fragment = graphql`
  fragment UnknownDocumentAttributes on ContentfulDocument {
    __typename
  }
`;

export default { test, create };
